export default {
  ticketBooks: state => state.ticketBooks,
  ticketBooksLoading: state => state.ticketBooksLoading
}
